export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8342.55bec230.jpg";